import axios from 'axios';
import AccessToken from '@/services/auth';
import signature from '@/services/signature';

const ACCESS_TOKEN = AccessToken();
const BASE_URI = process.env.VUE_APP_API_BASE_URI;

let config = {
	headers: {
		Authorization: 'Bearer ' + ACCESS_TOKEN.token,
		TimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
	}
};

class TaxInvoicesApi {
	async list(queryString = '') {
		try {
			const response = await axios.get(BASE_URI + '/v1/tax-invoices' + signature(queryString), config);
			return response;
		} catch (err) {
			throw err;
		}
	}
}

export const TaxInvoices = new TaxInvoicesApi();
